export default __webpack_public_path__ + "static/media/records_green.281ed239.svg";